import React, { useContext, useState, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import MarblesChart from '../components/MarblesChart'
import MarblesLegend from '../components/MarblesLegend'
import SummaryStatsBox from '../components/SummaryStatsBox'
import generateRiskCounts from '../ultils/generateRiskCounts'
import { Context as PortfolioContext } from '../contexts/portfolio'
import CompanySidebarList from '../components/CompanySidebarList/CompanySidebarList'
import {
  applyPortfolioRiskFilter,
  applyPortfolioUserFilters,
} from '../ultils/filterData'

const useStyles = makeStyles({
  chartContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: '#fff',
    borderRadius: 5,
    overflowX: 'hidden',
    width: '100%',
    flexWrap: 'nowrap',
  },
  legendWrapper: {
    flexBasis: '15%',
    flexShrink: 0,
    height: 500,
    position: 'relative',
    minWidth: 0,
    overflow: 'visible',
  },
  visArea: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 0,
  },
  indexBoard: {
    flexBasis: '16%',
    flexShrink: 0,
    minWidth: 0,
    marginRight: 10,
  },
  sidebar: {
    flexBasis: '30%',
    flexShrink: 0,
    maxWidth: '30%',
    // overflow: 'hidden',
    margin: '0 10px 10px 0',
    maxHeight: '500px',
    height: '500px',
  },
  indexBoardChild: {
    paddingTop: 30,
  },
  chartInnerWrapper: {
    width: '100%',
    maxWidth: '100%',
    minWidth: '300px',
    height: 500,
  },
})

const iniFilter = {
  sector: [],
  industry: [],
  region: [],
  country: [],
}
const PortfolioTodayCompanyPage = ({ tickers, riskType, tickerId }) => {
  const classes = useStyles()

  const { state, setActiveNode } = useContext(PortfolioContext)
  const [selectedFilter, setSelectedFilter] = useState(iniFilter)

  const filteredByUserFilters = useMemo(
    () => applyPortfolioUserFilters(tickers, selectedFilter),
    [tickers, selectedFilter],
  )

  const tickerData = useMemo(
    () =>
      applyPortfolioRiskFilter(
        filteredByUserFilters,
        state.activeNode,
        riskType,
      ),
    [filteredByUserFilters, state.activeNode, riskType],
  )

  const riskCountData = useMemo(
    () => generateRiskCounts(filteredByUserFilters, riskType),
    [filteredByUserFilters, riskType],
  )

  const setMarblesData = d => {
    setActiveNode(d)
  }

  const resetAllFilters = React.useCallback(() => {
    setSelectedFilter(iniFilter)
    setActiveNode(null)
  }, [])

  return (
    <div className={classes.chartContainer}>
      <div className={classes.legendWrapper}>
        <MarblesLegend
          data={riskCountData}
          setMarblesData={setMarblesData}
          activeNode={state.activeNode}
          isCompanyPage={true}
        />
      </div>
      <div className={classes.visArea}>
        <div className={classes.chartInnerWrapper}>
          <MarblesChart
            isEmptyData={state.tickersInPortfolio.length === 0}
            tickers={tickerData}
            riskType={riskType}
            group="none"
          />
        </div>
      </div>
      <div className={classes.indexBoard}>
        <div className={classes.indexBoardChild}>
          <SummaryStatsBox
            riskType={riskType}
            total={filteredByUserFilters.length}
            setMarblesData={setMarblesData}
            data={riskCountData}
            segmentClicked={state.activeNode}
            setSegmentClicked={setActiveNode}
          />
        </div>
      </div>
      <div className={classes.sidebar}>
        <CompanySidebarList
          data={tickerData}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          onResetAll={resetAllFilters}
          tickerId={tickerId}
        />
      </div>
    </div>
  )
}

export default PortfolioTodayCompanyPage
